export default "__VITE_ASSET__Cfzq2AYz__"